import { decodeJwt } from "jose";

export const isTokenExpired = (token, now = Date.now()) => {
  if (!token) {
    return true;
  }

  try {
    const payload = decodeJwt(token);
    if (payload.exp == null) {
      return true;
    }
    // exp is in seconds, now is in milliseconds
    return now >= payload.exp * 1000;
  } catch {
    // If we can't determine expiration, assume not expired (don't over-filter)
    return false;
  }
};

/**
 * Find the Cognito ID token from localStorage.
 * @returns {string | null} The token string or null if not found
 */
export const getCognitoIdToken = () => {
  const idTokenKey = Object.keys(localStorage).find(
    (key) =>
      key.startsWith("CognitoIdentityServiceProvider.") &&
      key.endsWith(".idToken"),
  );

  if (!idTokenKey) {
    return null;
  }

  return localStorage.getItem(idTokenKey);
};

/**
 * Check if the current Cognito session token in localStorage is expired.
 *
 * @returns {boolean} true if expired or no token found, false if valid
 */
export const isSessionTokenExpired = () => {
  const token = getCognitoIdToken();
  if (!token) {
    // No token found - consider this as "expired" for filtering purposes
    return true;
  }
  return isTokenExpired(token);
};
